<!-- Active store but no products -->
<ng-container *ngIf="storeActive(); else deactivated">
  <main class="sm:mx-0 bg-white my-8 rounded lg:mx-[152px] px-2 lg:px-0">
    <div class="w-full lg:w-1/3 mx-auto py-[130px] text-center">
      <img
        class="w-14 h-14 mx-auto"
        src="../../../assets/svg/productAdd.svg"
        alt="store icon"
      />
      <h4 class="font-semibold leading-3 lg:leading-8 text-zestBlack py-[9px]">
        No product added
      </h4>
      <p class="text-zestLabel text-sm tracking-wide mb-8">
        No product has been added to this store yet.
      </p>
    </div>
  </main>
</ng-container>

<!-- Deactivated store -->
<ng-template #deactivated>
  <main class="flex flex-col place-items-center place-content-center font-mont h-screen my-8 lg:my-0">
    <img src="../../assets/svg/deactivate.svg" alt="deactivate" />
    <p class="text-center pt-4 pb-2 text-zestBlack font-medium text-xl">
      404 Error
    </p>
    <p class="text-base font-medium leading-tight text-zestTertiary-500 text-center">
      No results found.
    </p>
    <button class="mt-6 bg-zestBlack text-white py-3 px-4 rounded-lg">
      <a target="_blank" rel="noreferrer noopener" [href]="marketplaceUrl">
        Explore more products
      </a>
    </button>
  </main>
</ng-template>
